import React,{useState,useEffect} from 'react'
import { StateUseContext } from '../context/UserDetailContext'
import { Link,useParams } from 'react-router-dom';
import BankDetailSidebar from '../components/bankTransfer/BankDetailSidebar';
// import BankTransferForm from '../components/bankTransfer/bankTransferForm';
import ChecqueForm from '../components/bankTransfer/ChecqueForm';
import PosDateCheque from '../components/bankTransfer/PosDateCheque';
import PosForm from '../components/bankTransfer/PosForm';

const BankTransfer = () => {
const {userDetail, feeDetail} = StateUseContext();

const qParams = useParams();
const {installment,lumpsum,currency_code} = feeDetail !==undefined && feeDetail
const [selectedInstallmentData, setSelectedInstallmentData] = useState(null);
const {installmentId,payType,userId} = qParams


useEffect(() => {

    if(userDetail !==undefined && feeDetail !==undefined){
    if(userDetail?.id == userId){
        if(payType==='1'){
            const foundInstallment = installment?.find(installment => installment.installment_number == installmentId);
            if(foundInstallment){
                setSelectedInstallmentData(foundInstallment)
            }
        }
        if(payType==='2'){
            setSelectedInstallmentData(lumpsum)
        }
    }
}
    
},[feeDetail,userDetail])



  return (
   <div className="container mt-5">
    <div className="row">
        <div className="col-6">
            <h6 className='fw-bold'>Offline Transfer (Cheque, Post-Dated Cheque and pos)</h6>
        </div>
        <div className="col-6 text-end">
            <Link to={'/student/dashboard'} className='text-secondary px-3 border-light border fw-medium py-2 bg-white shadow-sm rounded d-inline-block text-decoration-none'>Go To Dashboard</Link>
        </div>
    </div>

    <div className="row mt-2">
        <div className="col-lg-3 pb-4">
            <BankDetailSidebar selectedInstFeeDetail={selectedInstallmentData !==undefined && selectedInstallmentData} 
            currency={currency_code}/>
        </div>
        <div className="col-lg-9 bank_transfer_tabs">
            <nav>
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    {/* <button className="nav-link active" id="nav-banktransfer-tab" data-bs-toggle="tab" data-bs-target="#nav-banktransfer" type="button" role="tab" aria-controls="nav-banktransfer" aria-selected="true">Bank Transfer</button> */}
                    <button className="nav-link active" id="nav-cheque-tab" data-bs-toggle="tab" data-bs-target="#nav-cheque" type="button" role="tab" aria-controls="nav-cheque" aria-selected="false">Cheque</button>
                    <button className="nav-link" id="nav-postDateCheque-tab" data-bs-toggle="tab" data-bs-target="#nav-postDateCheque" type="button" role="tab" aria-controls="nav-postDateCheque" aria-selected="false">Post-Dated Cheque</button>
                    <button className="nav-link" id="nav-pos-tab" data-bs-toggle="tab" data-bs-target="#nav-pos" type="button" role="tab" aria-controls="nav-pos" aria-selected="false">POS</button>
                </div>
            </nav>
            <div className="tab-content pt-4" id="nav-tabContent">
                {/* <div className="tab-pane fade" id="nav-banktransfer" role="tabpanel" aria-labelledby="nav-banktransfer-tab" >
                    <BankTransferForm  
                    selectedInstFeeDetail={selectedInstallmentData !==undefined && selectedInstallmentData} 
                    currency={currency_code}
                    feeDetail={feeDetail !==undefined && feeDetail}
                    userDetail={userDetail !==undefined && userDetail}
                    />
                </div> */}
                <div className="tab-pane fade  show active" id="nav-cheque" role="tabpanel" aria-labelledby="nav-cheque-tab" >
                    <ChecqueForm
                        selectedInstFeeDetail={selectedInstallmentData !==undefined && selectedInstallmentData} 
                        currency={currency_code}
                        feeDetail={feeDetail !==undefined && feeDetail}
                        userDetail={userDetail !==undefined && userDetail}
                    />
                </div>
                <div className="tab-pane fade" id="nav-postDateCheque" role="tabpanel" aria-labelledby="nav-postDateCheque-tab" >
                    <PosDateCheque 
                        selectedInstFeeDetail={selectedInstallmentData !==undefined && selectedInstallmentData} 
                        currency={currency_code}
                        feeDetail={feeDetail !==undefined && feeDetail}
                        userDetail={userDetail !==undefined && userDetail}
                    />
                </div>
                <div className="tab-pane fade" id="nav-pos" role="tabpanel" aria-labelledby="nav-pos-tab" >
                    <PosForm 
                        selectedInstFeeDetail={selectedInstallmentData !==undefined && selectedInstallmentData} 
                        currency={currency_code}
                        feeDetail={feeDetail !==undefined && feeDetail}
                        userDetail={userDetail !==undefined && userDetail}
                    />
                </div>
            </div>
        </div>
    </div>
   </div>
  )
}

export default BankTransfer